import PostDetail from "../component/communityComp/PostDetail";

export default function CommunityPostPage() {
  return <PostDetail />;
}
